import React, {Component} from "react";
import CartItem from "./CartItem";
import Table from "../../components/Table";
import {pluralizeWithPrefix} from "../../lib/TextFormatter";
import {cx} from "../../lib/ClassSet";
import {List} from "immutable";
import "./ProductTable.css";

function getItemKeyForCartItem(item) {
  let suffix = item.get("subscription") === true ? "-sub" : "";
  return `${item.get("productSku")}${suffix}`;
}

class ProductTable extends Component {

  render() {

    let tableHeader = List([
      "Product",
      "Quantity",
      "Unit Price"
    ])

    if (this.props.showSubtotal) {
      tableHeader = tableHeader.push("Subtotal");
    }

    const subscriptionItems = this.props.products.filter((item) => item.get("subscription"))
    const normalItems = this.props.products.filter((item) => item.get("subscription") === false)
    const classes = cx({
      "ProductTable": true,
      "u-with-subscription": subscriptionItems.size > 0,
      "u-with-subtotal": this.props.showSubtotal
    })

    return (
      <div className={classes}>
        {this.renderSubscriptionItems(subscriptionItems, tableHeader, this.props.subscriptionFrequencyWeeks, this.props.subscriptionName)}
        {this.renderNormalItems(normalItems, tableHeader)}
      </div>
    )
  }

  renderSubscriptionItems(items, tableHeader, frequencyWeeks, subscriptionName) {
    if (items.size === 0) return null;
    let rendererParams = {showSubtotal: this.props.showSubtotal}
    let subscriptionTitle = (subscriptionName === "") ? "Subscription" : `Subscription "${subscriptionName}"`;
    return (
      <React.Fragment>
        <div className="header subscriptionHeader">
          <div className="title">{subscriptionTitle}</div>
          <div className="frequency">Delivery every {pluralizeWithPrefix(frequencyWeeks, "week", "weeks", true)}</div>
        </div>
        <Table 
          extraClassName="CartList SubscriptionCartList"
          data={items} 
          renderer={CartItem} 
          rendererParams={rendererParams}
          mode="table"
          tableHeader={tableHeader}
          onItemClick={this.handleItemClick.bind(this)}
          selected=""
          getItemKey={getItemKeyForCartItem}
          />
      </React.Fragment>
    )
  }

  renderNormalItems(items, tableHeader) {
    if (items.size === 0) return null;
    let rendererParams = {showSubtotal: this.props.showSubtotal}
    return (
      <React.Fragment>
        <div className="header">
          <div className="title">Products</div>
        </div>          
        <Table 
          extraClassName="CartList"
          data={items} 
          renderer={CartItem} 
          rendererParams={rendererParams}
          mode="table"
          tableHeader={tableHeader}
          onItemClick={this.handleItemClick.bind(this)}
          selected=""
          getItemKey={getItemKeyForCartItem}
          />
      </React.Fragment>
    )
  }  

  handleItemClick(itemData, e) {
    if (this.props.onItemClick) {
      e.preventDefault();
      e.stopPropagation();
      this.props.onItemClick(itemData);
    }
  }
}

ProductTable.defaultProps = {
  subscriptionFrequencyWeeks: 0,
  items: List([]),
  showSubtotal: true
}

export default ProductTable;